/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ filter: NonNullable<unknown> }} Error_Nav_No_Errors_Found_ToastInputs */



/**
* | output |
* | --- |
* | "No{filter} errors found." |
*
* @param {Error_Nav_No_Errors_Found_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_errors_found_toast = /** @type {((inputs: Error_Nav_No_Errors_Found_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Errors_Found_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Aucune${i?.filter} erreur trouvee.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Es wurden keine ${i?.filter}-Fehler gefunden.`)
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun errore trovato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибок PH0 не обнаружено.")
	if (locale === "es") return /** @type {LocalizedString} */ (`No se encontraron errores${i?.filter}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`未发现${i?.filter}错误。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.filter} エラーは見つかりませんでした。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`No${i?.filter} त्रुटियाँ पाई गईं।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum erro PH_0__ encontrado.")
	return /** @type {LocalizedString} */ (`No${i?.filter} errors found.`)
});